<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Steve Barber is a confident introvert who has greatly enjoyed writing since his early 20s. He has had a long, diverse and satisfying career in the health and beauty industry, and in addition to <em>German Girls</em>, he has written many children’s stories and poems for his beloved Sarah and Dan. Steve lives with his wonderful wife, Ine, and two cats on the south coast of England. His favourite authors are Anne Tyler, Chris Stewart and Alexander McCall Smith. Steve enjoys walking, wildlife watching and being by the sea.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?0e606854